<template>
<div>
    <div id="wiki_file_ino_popup"></div>
    <moo-popover
      :close-delay="0"
      popper-class="common-popper"
      placement="bottom-end"
      width="184"
      v-model="moreVisible"
      trigger="click"
      v-show="headerMoreComputed.length > 0"
      @show="onPopperShow"
      :disabled="readOnly"
    >
      <div class="office-pop" @mouseleave="onMouseleavePopperAction">
        <span
          :class="{
            'menu-item': true,
            'export-tip': data.id === 'export',
            transToTemplate: data.id === 'transToTemplate',
          }"
          :key="data?.id"
          @click="(event) => handleMore(data)"
          v-for="data in this.headerMoreComputed.filter(
            (obj) => Object.keys(obj).length !== 0
          )"
        >
          <FileOperateBtn
            v-if="data.id === 'fileOperationHistory'"
            @onvisibale="onFileOperateVisible"
            @onselectionchange="fileInfoPopUpAction"
            :contentType="contentType"
          >
            <div class="more-tip" style="height: 32px;">
              <svg-icon
                class-name="file-icon"
                :icon-class="data.icon"
              ></svg-icon>
              {{ data.name }}
              <svg-icon
                class-name="file-icon arrow-file"
                icon-class="arrow-right"
              ></svg-icon>
            </div>
          </FileOperateBtn>
          <div v-else class="more-tip">
            <svg-icon class-name="file-icon" :icon-class="data.icon"></svg-icon>
            {{ data.name }}
            <svg-icon
              v-if="data.id === 'export'"
              class-name="file-icon arrow-file"
              icon-class="arrow-right"
            >
            </svg-icon>
            <div v-if="data.id === 'transToTemplate'">
              <!-- <moo-switch
                v-model="isTemplate"
                active-color="#5C70FF"
                inactive-color="#E6E9ED"
                @change="templateSwitchChange"
              ></moo-switch> -->
            </div>
          </div>
          <div
            v-if="data.id === 'export'"
            ref="exportPopper"
            class="export-popper"
          >
            <span
              @click="(event) => handleExport(data.type)"
              :key="data?.icon"
              v-for="data in exportOptions"
            >
              <svg-icon
                class-name="file-icon"
                :icon-class="data.icon"
              ></svg-icon>
              {{ data.name }}
            </span>
          </div>
        </span>
      </div>
      <svg-icon
        slot="reference"
        :style="moreStyle"
        class-name="header-icon more-file"
        :class="{
          'more-file-metting': isMettingDoc,
          'more-file-readonly': readOnly,
        }"
        icon-class="file-more"
      ></svg-icon>
    </moo-popover>
    <DeleteDialog
      @goHome="goHome"
      :fileName="(metadata || {})?.fileName"
      :fileId="fileId"
      ref="delete"
    >
    </DeleteDialog>
  </div>
</template>

<script>
import { intl } from 'tci18n-vue2'
import DeleteDialog from "../dialog/deleteDialog.vue";
import utils from "@/core/h5/utils";
import FileOperateBtn from "./FileOperateBtn.vue";
import { TocaWikiFileInoPopup } from "@toca/toca-wiki-template";
import { getFileViewRecord, getFileOperateRecords } from "@/api/h5/file";
import { mapActions, mapState } from "vuex";
import { navigatorLang } from "@/utils/lang";
import { AllAuthUp, WriteAuthUp, ReadDownloadAuthUp, ReadAuthUp } from "../../utils/authUtil";
import Read from "../tip/read.vue";

export default {
  props: {
    isTemplate: {
      type: Boolean
    },
    fileId: {
      type: String
    },
    auth: {
      type: String
    },
    isWps: {
      type: Boolean
    },
    isWiki: {
      type: Boolean
    },
    isHome: {
      type: Boolean
    },
    isEditor: {
      type: Boolean
    },
    isOtherFile: {
      type: Boolean
    },
    is_inTocaApp: {
      type: Boolean
    },
    officeFileType: {
      type: String
    },
    isFileOwner: {
      type: Boolean
    },
    isMettingDoc: {
      type: Boolean
    },
    metadata: {
      type: Object
    },
    exportOptions: {
      type: Array
    },
    precheckDocInfo: {
      type: Object
    },
    currentUser: {
      type: Object
    },
    isHasTemplateAuth: {
      type: Boolean
    },
    contentType: {
      type: String
    },
    isSafe: {
      type: Boolean,
      default: false
    }
  },
  name: "MorePopper",
  components: {
    DeleteDialog,
    FileOperateBtn
  },
  data() {
    return {
      fileInoPopup: null,
      fileInoPopupVisible: false,
      moreVisible: false,
      headerMore: []
    };
  },
  methods: {
    onFileOperateVisible(visibility) {
      if (visibility) {
        this.moreVisible = this.fileInoPopupVisible = visibility;
      } else {
        this.fileInoPopupVisible = false;
      }
    },
    onMouseleavePopperAction() {
      this.moreVisible = this.fileInoPopupVisible;
    },
    templateSwitchChange() {
      this.$emit("templateSwitchChange");
    },
    onPopperShow() {
      this.$emit("onPopperShow");
    },
    getTemplateItem() {
      const docTypes = ["DOCUMENT", "WORD", "EXCEL", "PPT"];
      const docType = this.contentType?.toUpperCase();
      const isDocType = docType && docType.length > 0 && docTypes.includes(docType);
      //模板转换or保存
      const creatorInfo = this.precheckDocInfo?.creatorInfo;
      const currentUser = this.currentUser;
      let isCreator = creatorInfo?.userId === currentUser.userId && creatorInfo?.spaceId === currentUser.spaceId;
      let templateItem = null;
      if (isDocType === true) {
        if (isCreator === true) {
          //自己的文章，可以转换为模板
          const templateType = this.precheckDocInfo?.templateType;
          const iconName = "template_brand_gray";
          const templateTitle = templateType === 0 ? intl.$t("转换为模板#!!!#src/pages/H5/Cloud/components/popper/morePopper.vue_1") : intl.$t("取消模板#!!!#src/pages/H5/Cloud/components/popper/morePopper.vue_1");
          templateItem = { name: templateTitle, id: "transToTemplate", icon: iconName };
        } else {
          //别人的文章，可以保存
          templateItem = { name: intl.$t("保存为我的模板#!!!#src/pages/H5/Cloud/components/popper/morePopper.vue_1"), id: "saveToTemplate", icon: "template_brand_gray" };
        }
      }

      let items = [];
      if (templateItem !== null) items.push(templateItem);
      return items;
    },
    handleDelete() {
      if (this.isWiki) {
        window.parent.postMessage(
          {
            type: "deleteFile",
            fileId: this.fileId //要跳转到知识库文件id
          },
          "*"
        );
      } else {
        this.$refs.delete.handleDeleteDialog(true, this.metadata);
      }
    },
    showMore() {
      return this.headerMoreComputed.length > 0;
    },
    handleMore(data) {
      if (data.id !== "fileOperationHistory") this.moreVisible = false;
      this.$emit("handleMore", data);
    },
    handleExport(type) {
      this.$emit("handleExport", type);
    },
    goHome() {
      window.location.replace(`https:${process.env.VUE_APP_WIKI_URL}`);
    },
    fileInfoPopUpAction(index) {
      this.moreVisible = false;
      this.fileInoPopup?.setPopupVisible(true, index, this.contentType);
    }
  },
  computed: {
    ...mapState({
      cloudHomeI18n: (state) => state.cloudHomeI18n,
      officePreviewModeInfo: (state) => state.officePreviewModeInfo,
      wikiSpaceInfo: (state) => state.wikiSpaceInfo
    }),
    isTencentDoc() {
      if (
      this.officePreviewModeInfo &&
      this.officePreviewModeInfo.enabledOfficePreview)
      {
        return this.officePreviewModeInfo.enabledOfficePreview === true;
      }
      return false;
    },
    readOnly() {
      return this.wikiSpaceInfo?.wikiSpaceSettings?.readOnly;
    },
    moreStyle() {
      return this.isWiki || this.is_inTocaApp || this.isHome ?
      { marginLeft: 12 } :
      {};
    },
    headerMoreComputed() {
      // 所有菜单选项
      const fullscreenItem = { name: intl.$t("演示模式#!!!#src/pages/H5/Cloud/components/popper/morePopper.vue_1"), icon: "cloud-fullscreen", id: "tocaeditor-fullscreen" };
      const exportPDFItem = { name: intl.$t("下载为PDF#!!!#src/pages/H5/Cloud/components/popper/morePopper.vue_1"), icon: "file-pdf", id: "export-wiki" };
      const downloadItem = { name: intl.$t("下载为#!!!#src/pages/H5/Cloud/components/popper/morePopper.vue_1"), id: "export", icon: "file-export" };
      const historyItem = { name: intl.$t("历史记录#!!!#src/pages/H5/Cloud/components/popper/morePopper.vue_1"), id: "history", icon: "file-history" };
      const applyAuthItem = { name: intl.$t("申请更多权限#!!!#src/pages/H5/Cloud/components/popper/morePopper.vue_1"), id: "apply-auth", icon: "file-apply-auth" };
      const templateItem = this.getTemplateItem(); // 数组
      const moveItem = { name: intl.$t("移动到#!!!#src/pages/H5/Cloud/components/popper/morePopper.vue_1"), id: "move", icon: "file-move" };
      const copyItem = { name: intl.$t("创建副本#!!!#src/pages/H5/Cloud/components/popper/morePopper.vue_1"), id: "copy", icon: "file-copy" };
      const operationHistoryItem = { name: intl.$t("操作记录#!!!#src/pages/H5/Cloud/components/popper/morePopper.vue_1"), icon: "file-pdf", id: "fileOperationHistory" };
      const transferItem = this.isHome ? {} : { name: intl.$t("转移所有权#!!!#src/pages/H5/Cloud/components/popper/morePopper.vue_1"), id: "transfer", icon: "file-transfer" };
      const settingItem = { name: intl.$t("设置#!!!#src/pages/H5/Cloud/components/popper/morePopper.vue_1"), id: "setting", icon: "edit-setting" };
      const deleteItem = this.isHome ? {} : { name: intl.$t("删除#!!!#src/pages/H5/Cloud/components/popper/morePopper.vue_1"), id: "delete", icon: "cloud-file-delete" };
      // 判断条件
      const docTypes = ["DOCUMENT", "WORD", "EXCEL", "PPT"];
      const docType = this.contentType?.toUpperCase();
      const isDocType = docType && docType.length > 0 && docTypes.includes(docType); // 是否是文档类型
      const auth = this.auth; // 文档权限
      const isEditor = this.isEditor; // 是否是编辑器
      const isPDF = this.officeFileType === "f" || this.contentType === 'PDF'; // 是否是PDF
      const isFileOwner = this.isFileOwner; // 是否是文件所有者
      const isShareMe = this.precheckDocInfo?.source === 'SHARE_ME';

      // 组合菜单选项
      const menuItems = [];
      // 演示模式(查看及以上权限 + 轻文档)
      if (ReadAuthUp(auth) && isEditor) {menuItems.push(fullscreenItem);}
      // 下载为pdf(查看下载及以上权限 + 轻文档)
      if (ReadDownloadAuthUp(auth) && isEditor) {menuItems.push(exportPDFItem);}
      // 下载为（查看下载及以上权限 + WORD/EXCEL/PPT文档）
      if (ReadDownloadAuthUp(auth) && isDocType && !isEditor) {menuItems.push(downloadItem);}
      /* 历史记录
          1. 轻文档 + 查看及以上权限
          2. WORD/EXCEL/PPT文档 + 编辑及以上权限
      */
      if (isEditor && ReadAuthUp(auth) || isDocType && !isEditor && WriteAuthUp(auth)) {
        menuItems.push(historyItem);
      }
      // 特殊处理特别文档，不展示历史记录
      const docIds = ['1e16c643309e48daa8481bfc1a86d7a7', '8a756447f284454ba35a58980e5fe04c'];
      if (docIds.includes(this.fileId) && this.isFileOwner === false) {
        // 如果menuitems有历史记录，删除
        const historyIndex = menuItems.findIndex((item) => item.id === 'history');
        if (historyIndex !== -1) {
          menuItems.splice(historyIndex, 1);
        }
      }
      // 申请更多权限 （非所有权）
      if (AllAuthUp(auth) === false) {menuItems.push(applyAuthItem);}
      // 模版转换（查看下载及以上权限 + DOCUMENT/WORD/EXCEL/PPT文档）
      if (templateItem.length > 0) {menuItems.push(...templateItem);}
      // 移动到 (所有权 + 非共享)
      if (AllAuthUp(auth) && !isShareMe && !this.isSafe) {menuItems.push(moveItem);}
      // 创建副本 （查看下载及以上权限）
      if (ReadDownloadAuthUp(auth) && !this.isSafe) {menuItems.push(copyItem);}
      // 操作记录 （所有权）
      if (AllAuthUp(auth) || isFileOwner) {menuItems.push(operationHistoryItem);}
      // 转移所有权 (文档所有者)
      if (isFileOwner) {menuItems.push(transferItem);}
      // 设置 (阅读及以上权限， 里面有一个默认的设置新建文件连接分享范围)
      if (ReadAuthUp(auth)) {menuItems.push(settingItem);}
      // 删除 (所有权)
      if (AllAuthUp(auth)) {menuItems.push(deleteItem);}
      return menuItems;
    }
  },
  watch: {},
  mounted() {
    this.fileInoPopup = new TocaWikiFileInoPopup("#wiki_file_ino_popup", {
      fetchData: async (since, size, scene) => {
        if (scene === "VISIT") {
          return getFileViewRecord(this.fileId, since, size);
        }
        return getFileOperateRecords(this.fileId, since, size, scene);
      },
      locale:
      this.cloudHomeI18n ||
      localStorage.getItem("tci18nLocale") ||
      navigatorLang[navigator.language] ||
      "zh-cn"
    });
  },
  destroyed() {
    this.fileInoPopup?.destroy();
  }
};
</script>

<style lang="scss" scoped>
.common-popper {
  width: 184px !important;
  padding: 4px 4px !important;
  height: 112px;
  background: #ffffff;
  border: 1px solid #e6e8ec !important;
  box-shadow: 0 8px 12px 0 #1213171a !important;
  border-radius: 8px !important;
  box-sizing: border-box;
  height: auto !important;
  width: 146px !important;
  margin-top: 8px !important;

  .popper__arrow {
    display: none !important;
  }
}

.office-pop {
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: flex-end;

  .export-popper {
    display: none;
    position: absolute;
    width: 184px;
    height: auto;
    left: -174px;
    top: -8px;
    background: #ffffff;
    border: 1px solid #e6e8ec;
    box-shadow: 0 8px 12px 0 #1213171a;
    border-radius: 8px;
    flex-flow: column;
    align-items: center;
    justify-content: center;
    padding: 4px;

    span {
      justify-content: flex-start;

      &:hover {
        background: #f4f6f9;
      }
    }

    &:hover {
      display: flex;
    }
  }

  .export-tip {
    width: 200px;
  }

  .export-tip:hover {
    .export-popper {
      display: flex;
    }
  }

  span {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    font-weight: 400;
    font-size: 14px;
    color: #222329;
    letter-spacing: 0;
    width: 184px;
    height: 32px;
    margin: 4px 0;
    background: transparent;
    border-radius: 8px;
    line-height: 20px;
    box-sizing: border-box;
    position: relative;
    cursor: pointer;

    .more-tip {
      width: 174px;
      height: 100%;
      background: #ffffff;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      border-radius: 8px;

      &:hover {
        background: #f4f6f9;
      }
    }

    .file-icon {
      width: 16px;
      height: 16px;
      margin: 0 8px;
    }

    .arrow-file {
      position: absolute;
      top: 0;
      bottom: 0;
      right: 8px;
      margin: auto 0;
    }
  }

  .menu-item:first-child {
    margin-top: 0px !important;
  }

  .menu-item:last-child {
    margin-bottom: 0px !important;
  }
}

.header-icon {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px;
  width: 16px;
  height: 16px;
}

.header-icon:hover {
  background: #f4f6f9;
  border-radius: 4px;
}

.more-file-readonly {
  cursor: not-allowed !important;
}

.more-file {
  margin-left: 17px;
  outline: none !important;
}

.more-file-metting {
  margin-left: 0px !important;
}
</style>

<style lang="scss">
.transToTemplate {
  .more-tip {
    justify-content: space-between;
    position: relative;
  }

  .switch_container {
    position: absolute;
    right: 8px;
    margin-left: 38px;
    width: 24px;
    height: 12px;
    display: flex;
    align-items: center;
    justify-self: center;

    .is-checked {
      .moo-switch__core {
        height: 12px;

        &::after {
          left: unset !important;
          right: 0px !important;
          margin-left: unset !important;
        }
      }
    }

    .moo-switch {
      width: 24px;
      height: 12px;

      .moo-switch__core {
        height: 12px;

        &::after {
          right: unset;
          left: 0px;
          top: 0px;
          width: 10px;
          height: 10px;
        }
      }
    }
  }
}
</style>
